import Grid from '@mui/material/Grid';

export default function BacteriaFooterComponent() {
  return (
    <Grid
      container
      data-test='BacteriaFooterComponent'
      style={{
        height: '240px',
        backgroundImage: "url('/gif/53842-bacterias.gif')",
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'center',
      }}
    />
  );
}
